/**
 * Validate a Canadian Social Insurance Number (SIN)
 * @param  {string} sinText - A 9-digit Canadian SIN
 * @return {bool} - Validity of the input SIN
 */
export function isValidSIN(sinText) {
    const trimmedSin = sinText.trim().replaceAll(' ', '');
    if (trimmedSin.length === 9) {
        // convert to an array & pop off the check digit
        const sin = trimmedSin.split('');
        const check = parseInt(sin.pop(), 10);
        const even = sin
            // take the digits at the even indices
            .filter((_, i) => {
            return i % 2;
        })
            // multiply them by two
            .map((n) => {
            return parseInt(n, 10) * 2;
        })
            // and split them into individual digits
            .join('')
            .split('');
        const tot = sin
            // take the digits at the odd indices
            .filter((_, i) => {
            return !(i % 2);
        })
            // concatenate them with the transformed numbers above
            .concat(even)
            // it's currently an array of strings; we want numbers
            .map((n) => {
            return parseInt(n, 10);
        })
            // and take the sum
            .reduce((acc, cur) => {
            return acc + cur;
        });
        // compare the result against the check digit
        return check === (10 - (tot % 10)) % 10;
    }
    return false;
}
